export default function AnswerChoosedCheck() {
    return <svg data-name="answer-choosed-check">
        <path className="cls-1" d="M69.94,11.94a8.84,8.84,0,0,0-12.48,0l-28.7,28.7-13-13A8.82,8.82,0,1,0,3.3,40.13l19,19c.06.06.1.15.18.22a8.87,8.87,0,0,0,12.5,0l.14-.16,34.78-34.8A8.81,8.81,0,0,0,69.94,11.94Z"/>
        <path className="cls-2" d="M69.23,2.58a8.84,8.84,0,0,0-12.48,0L28.05,31.29l-13-13A8.82,8.82,0,0,0,2.58,30.77l19,19c.06.07.1.15.17.22a8.8,8.8,0,0,0,7.93,2.41A8.69,8.69,0,0,0,34.31,50s.08-.11.13-.16l34.79-34.8A8.82,8.82,0,0,0,69.23,2.58Z"/>
    </svg>;
}
